import React from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const LocationContainer = styled.section`
  padding: 80px 0;
  background: #ffffff;
`;

const LocationWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const MapWrapper = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  height: 100%;
  min-height: 400px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LocationH1 = styled.h1`
  font-size: 2.5rem;
  color: #4F4C4C;
  margin-bottom: 2rem;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  color: #4F4C4C;

  svg {
    color: #c77408;
    font-size: 1.5rem;
    margin-right: 15px;
  }
`;


const Location = () => {
  return (
    <LocationContainer id="location">
      <LocationWrapper>
        <MapWrapper>
		  <iframe 
		    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30573.54611115684!2d-49.230562!3d-16.692226!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef12370b09975%3A0xd7591b21a7c3ada!2sPrimeira%20Linha%20Servi%C3%A7os%20Automotivos!5e0!3m2!1spt-BR!2sbr!4v1758114013838!5m2!1spt-BR!2sbr" 
		    width="100%" 
		    height="100%" 
		    style={{border:0}} 
		    allowFullScreen="" 
		    loading="lazy" 
		    referrerPolicy="no-referrer-when-downgrade"
		    title="Mapa da localização da Primeira Linha Reparação Veicular"> 
		  </iframe>
		</MapWrapper>
        <InfoWrapper>
          <LocationH1>Venha nos Visitar</LocationH1>
          <InfoItem>
            <FaMapMarkerAlt />
            <div>
              Av. Santos, 181 - Jardim Novo Mundo, Goiânia - GO, 74715-450
              <br/>
              <small>(Próximo ao Estádio Serra Dourada)</small>
            </div>
          </InfoItem>
          <InfoItem>
            <FaPhone />
            (62) 3284-3050
          </InfoItem>
          <InfoItem>
            <FaEnvelope />
            primeiralinharv@hotmail.com
          </InfoItem>
          <InfoItem>
            <FaClock />
            Segunda a Sexta: 8h às 18h
          </InfoItem>
        </InfoWrapper>
      </LocationWrapper>
    </LocationContainer>
  );
};

export default Location;